import { render, staticRenderFns } from "./building.vue?vue&type=template&id=56072e22&scoped=true&"
import script from "./building.vue?vue&type=script&lang=js&"
export * from "./building.vue?vue&type=script&lang=js&"
import style0 from "./building.vue?vue&type=style&index=0&id=56072e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56072e22",
  null
  
)

export default component.exports